import { useQuery, QueryHookOptions } from '@apollo/client';
import { GET_MY_LOCATIONS_V2, GET_MY_LOCATIONS_V2_LEAN } from './queries';

export type GetMyLocationsV2Input = {
  page?: number;
  limit?: number;
  q?: string;
};

export type GetMyLocationsV2ListItem = {
  id: number;
  name?: string | null;
  address?: string | null;
  city?: string | null;
  state?: string | null;
  zipCode?: string | null;
  timezone?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  taxRate?: number | null;
  phoneNumber?: string | null;
  description?: string | null;
  userId?: string | null;
  operatingHours?: Array<{
    id?: string | null;
    PickupLocationType?: string | null;
    alwaysAvailable?: boolean | null;
  } | null> | null;
};

export type GetMyLocationsV2LeanItem = {
  id: number;
  name?: string | null;
  address?: string | null;
  city?: string | null;
  state?: string | null;
  zipCode?: string | null;
  timezone?: string | null;
  latitude?: number | null;
  longitude?: number | null;
};

export type GetMyLocationsV2QueryData = {
  getMyLocationsV2: {
    totalCount: number;
    hasMore: boolean;
    page: number;
    limit: number;
    totalPages: number;
    items: GetMyLocationsV2ListItem[];
  };
};

export type GetMyLocationsV2LeanQueryData = {
  getMyLocationsV2: {
    totalCount: number;
    hasMore: boolean;
    page: number;
    limit: number;
    totalPages: number;
    items: GetMyLocationsV2LeanItem[];
  };
};

export type GetMyLocationsV2QueryVars = {
  input: GetMyLocationsV2Input;
};

export function useGetMyLocationsV2Query(
  options?: QueryHookOptions<GetMyLocationsV2QueryData, GetMyLocationsV2QueryVars>,
) {
  return useQuery<GetMyLocationsV2QueryData, GetMyLocationsV2QueryVars>(
    GET_MY_LOCATIONS_V2,
    options,
  );
}

export function useGetMyLocationsV2LeanQuery(
  options?: QueryHookOptions<GetMyLocationsV2LeanQueryData, GetMyLocationsV2QueryVars>,
) {
  return useQuery<GetMyLocationsV2LeanQueryData, GetMyLocationsV2QueryVars>(
    GET_MY_LOCATIONS_V2_LEAN,
    options,
  );
}
